import { useCallback, useEffect, useState } from "react";
import { IError } from "itsf-ui-common";
import { IHpp } from "../IStancerPayment";
import { IHppResponse, mapHpp } from "../mappers/mapHpp";
import { mapHppPayload } from "../mappers/mapHppPayload";
import { PAYMENT_STANCER_URL } from "@constants";
import { useFetch } from "@hooks/useFetch";

interface IParams {
    validatePaymentApiRoute: string;
    iframePaymentApiRoute: string;
    successCallback(): void;
    errorCallback?(error: IError): void;
}

export const useStancerPaymentIframe = (props: IParams) => {
    const { validatePaymentApiRoute, iframePaymentApiRoute, successCallback, errorCallback } = props;
    const [iframeFetchState, { get, post }] = useFetch();
    const [iframeKey, setIframeKey] = useState(0);
    const [hpp, setHpp] = useState<IHpp>();

    const getIFrame = useCallback(() => {
        get<IHppResponse>(iframePaymentApiRoute, { forwardError: Boolean(errorCallback) })
            .then((hppResponse) => {
                if (hppResponse) {
                    setHpp(mapHpp(hppResponse));
                }
            })
            .catch(errorCallback);
    }, [errorCallback, get, iframePaymentApiRoute]);

    const submitPayment = useCallback(
        (event: MessageEvent) => {
            if (event.origin !== PAYMENT_STANCER_URL) {
                return;
            }

            if (event.data.status !== "finished") {
                return;
            }

            if (hpp) {
                post(validatePaymentApiRoute, {
                    body: mapHppPayload(hpp.paymentIntentId),
                    forwardError: true,
                })
                    .then(successCallback)
                    .catch(() => setIframeKey((prevState) => prevState + 1));
            }
        },
        [hpp, post, successCallback, validatePaymentApiRoute]
    );

    useEffect(() => {
        window.addEventListener("message", submitPayment, false);

        return () => window.removeEventListener("message", submitPayment);
    }, [submitPayment]);

    useEffect(() => {
        getIFrame();
    }, [getIFrame]);

    return {
        iframeFetchState,
        iframeKey,
        getIFrame,
        submitPayment,
        hpp,
    };
};
